<template>
  <div ref="box_preview_now" id="box_preview_now_box">
    <div v-if="!OnShowCanvas">
      <Skeleton/>
    </div>
    <div v-else style="position:relative">
      <v-stage
        ref="stateCanvas"
        v-if="this.mockups()[0] !== null"
        :config="stageConfig"
        class="omcustom-preview-print"
        :style="style"
      >
        <v-layer>
          <v-rect
            v-if="'width' in stageConfig"
            :config="{
            width: stageConfig.width / stageConfig.scale.x,
            height: stageConfig.height / stageConfig.scale.x,
            fill: '#716F75',
          }"
          />
          <print-area-preview
            :layer="LayerPrintarea"
            :key="LayerPrintarea.id"
            :name_layer="name_layer"
            :scaleDom="scaleDom"
            :ratio="mockupRatio"
            @setPrintAreaConfig="setPrintAreaConfig"
            @setArtworkWidth="setArtworkWidth"
          />
          <v-text
            ref="textRef"
            :config="{...configTextCopyright}"
          />
          <v-transformer
            ref="transformer"
            shouldOverdrawWholeArea="true"
            @transformend="onTransformend"
            @dragend="onDragMove"
          />
        </v-layer>
      </v-stage>
    </div>
  </div>
</template>

<script>
import Group from "../Mockup/Group";
import Image from "../Mockup/Image";
import PrintAreaPreview from './PrintAreaPreview'
import { mapGetters } from "vuex";
import {map, get, pick, concat, max} from 'lodash'
import Skeleton from '../Utilities/Skeleton'
import jQuery from 'jquery'
export default {
  name: "PreviewPrint",
  components: {
    group: Group,
    'm-image': Image,
    PrintAreaPreview,
    Skeleton
  },
  props: {
    name_layer: {
      type: String,
      default(){
        return "";
      }
    }
  },
  data() {
    return {
      loadings: {},
      mockupID: null,
      mockupRatio: null,
      isDragging: false,
      selectedShapeName: '',
      OnShowCanvas: false,
      propsChange: null,
      boxSize: {},
      scaleDom: 7.7,
      dataSetPrintAreaConfig: {},
      dataSetArtworkWidth: 1000
    }
  },
  mounted() {
    jQuery('.konvajs-content')
      .removeClass('konvajs-content')
      .addClass('fabric-content')
    this.selectedShapeName = this.name_layer;

    const mockups = get(this.mockups()[0], 'layers');
    let layers = mockups.find((e)=> e.type == "Printarea");

    localStorage.setItem('layersPreview_'+ this.name_layer, JSON.stringify(layers));

    this.$emit('setScaleNow', this.scaleNow());
    const box_preview = jQuery('#box_preview_now_box');
    if(box_preview.length >= 1){
      const width_box = box_preview.width();
      const artwork = this.artworks()[0];
      const x = width_box / artwork.width;
      this.scaleDom = 6;
      const boxSize = {
        width: Number(artwork.width * x),
        height: Number(artwork.height * x),
        ratio: x
      }
      this.boxSize = boxSize;
      const OnThis = this;
      this.mockupID = this.mockups()[0].id;
      this.mockupRatio = this.ratio();
      setTimeout(()=> {
        OnThis.OnShowCanvas = true;
        setTimeout(()=> {
          OnThis.updateTransformer();
        }, 500);
      }, 500);
    }
  },
  computed: {
    configTextCopyright(){
      const text = this.getHostName();
      var fontSize = this.calculateFontSize(this.stageConfig.width, text);
      const config = {
        align: 'center',
        ellipsis: true,
        fill: '#ABB8C3',
        fillAfterStrokeEnabled: true,
        fillPriority: 'color',
        fontFamily: 'fXmXx0Mxgz-regular',
        fontSize: fontSize / this.stageConfig.scale.x,
        // height: this.stageConfig.height / this.stageConfig.scale.y,
        letterSpacing: 1.3017384557620613 * 8,
        lineHeight: 1,
        offsetX: 0,
        offsetY: 0,
        padding: 0,
        ratio: 0.1,
        rotation: 0,
        scaleX: 1,
        scaleY: 1,
        skewX: 0,
        skewY: 0,
        type: 'Text',
        verticalAlign: 'middle',
        visible: true,
        width: this.stageConfig.width  / this.stageConfig.scale.x,
        wrap: 'none',
        wrapConfig: 'word',
        x: 1,
        y: 1,
        listening: true,
        text: text  //this.getHostName(),
      }
      return config;
    },
    
    stageConfig(){
      const boxSize = this.boxSize;
      return {
        width: boxSize.width ? boxSize.width : 650,
        height: boxSize.height ? boxSize.height : 535,
        scale: { x: boxSize.ratio ? boxSize.ratio : 0.1, y: boxSize.ratio ? boxSize.ratio : 0.1 },
        x: 1,
        y: 1,
        listening: true
      }
    },
    LayerPrintarea(){
      const layersPreview = localStorage.getItem('layersPreview_'+ this.name_layer);
      let layers = JSON.parse(layersPreview);
      const artworks = this.artworks()[0];
      layers.x = 1;
      layers.y = 1;
      layers.width = artworks.width / this.scaleDom;
      layers.height = artworks.height / this.scaleDom;
      layers.scaleX = 1;
      layers.scaleY = 1;
      return layers;
    },
  },
  methods: {
    ...mapGetters(['template', 'personalized', 'mockupLoadings', 'mockups', 'artworks', 'ratio', 'siteURL']),
    style(){
      return {
        position: "absolute",
        top: 0,
        height: "max-content !important",
        paddingBottom: `${(this.mockups()[0].height / this.mockups()[0].width) * 100}%`
      }
    },
    calculateFontSize(boxWidth, text) {
      var fontSizeMin = 1; // Kích thước font chữ tối thiểu
      var fontSizeMax = 70; // Kích thước font chữ tối đa
      var container = document.createElement('div');
      container.style.visibility = 'hidden';
      container.style.position = 'absolute';
      container.style.width = 'auto';
      container.style.height = 'auto';
      container.style.whiteSpace = 'nowrap';
      container.style.fontSize = fontSizeMax + 'px'; // Bắt đầu với kích thước font tối đa
      container.innerHTML = text;
      document.body.appendChild(container);
      // Binary search để xác định kích thước font chữ phù hợp
      while (fontSizeMax - fontSizeMin > 1) {
        var fontSizeMid = Math.floor((fontSizeMin + fontSizeMax) / 2);
        container.style.fontSize = fontSizeMid + 'px';
        if (container.clientWidth > boxWidth) {
          fontSizeMax = fontSizeMid;
        } else {
          fontSizeMin = fontSizeMid;
        }
      }
      document.body.removeChild(container);
      return fontSizeMin;
    },
    ratioNow() {
      var ratio = 1
      if (this.artworks()[0].width && this.artworks()[0].height) {
        var r = max([this.artworks()[0].width, this.artworks()[0].height])
        var res = 10
        for (; res > 1; res--) {
          if (r * res <= 10000) {
            break
          }
        }
        ratio = res / 10
      }
      return ratio
    },
    scaleNow(){
      return this.dataSetArtworkWidth / (this.artworks()[0].width * this.ratioNow());
    },
    onTransformend(e){
      const transformerNode = this.$refs.stateCanvas.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;
      const selectedNode = stage.findOne('.' + selectedShapeName);
      const attrs = selectedNode.attrs;
      let config = {};
      config.scaleX = attrs.scaleX;
      config.scaleY = attrs.scaleY;
      config.rotation = attrs.rotation;
      config.skewX = attrs.skewX;
      config.skewY = attrs.skewY;
      config.x = attrs.x;
      config.y = attrs.y;
      this.$emit('onChangeConfigImage', {
        id: this.selectedShapeName,
        scale: this.scaleNow(),
        configs: config
      });
    },
    onDragMove(e){
      const node = e.target._nodes[0];
      const id = node.id();
      const attrs = node.attrs;
      let config = {};
      config.x = attrs.x;
      config.y = attrs.y;
      this.$emit('onChangeConfigImage', {
        id: this.selectedShapeName,
        scale: this.scaleNow(),
        configs: config
      });
    },
    getHostName(){
      const hostName = window.location.hostname;
      const link = hostName.replace("https://", "");
      const name = link.charAt(0).toUpperCase() + link.slice(1)
      return name;
    },
    updateTransformer() {
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();
      const { selectedShapeName } = this;

      const selectedNode = stage.findOne('.' + selectedShapeName);
      if (selectedNode === transformerNode.node()) {
        return;
      }
      if (selectedNode) {
        transformerNode.nodes([selectedNode]);
      } else {
        transformerNode.nodes([]);
      }
    },
    setPrintAreaConfig(v){
      this.dataSetPrintAreaConfig = v;
    },
    setArtworkWidth(v){
      this.dataSetArtworkWidth = v;
    }
  }
}
</script>
<style>
.omcustom-preview-print{
  width: 100% !important;
}

.omcustom-preview-print .fabric-content canvas {
  width: 100% !important;
  height: auto !important;
  background-color: #e6e6e6 !important;
}
@media only screen and (max-width: 739px){
  .box-container-modal-cutface .omcustom-preview-print .fabric-content {
    width: 100% !important;
    overflow: hidden;
  }
}
</style>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/PreviewArtwork/PreviewPrint.vue